var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-loader"},[_c('input',{ref:"input",staticClass:"file-input",attrs:{"type":"file","accept":_vm.accept},on:{"click":_vm.clearValue,"input":_vm.onFileLoad,"dragenter":_vm.dragenter,"dragleave":_vm.dragleave,"drop":_vm.drop}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }